// extracted by mini-css-extract-plugin
module.exports = {"element":"_02712f2b3b--element--RV4UP","primary":"_02712f2b3b--primary--m4YSw","size-s":"_02712f2b3b--size-s--MQwrR","size-l":"_02712f2b3b--size-l--yX4Rz"};